var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.fecha(_vm.venta.fecha_de_venta)))]),_c('td',[_vm._v(_vm._s(_vm.venta.persona.nombre))]),_c('td',[_vm._v(_vm._s(_vm.venta.persona.apellido))]),_c('td',[_vm._v(_vm._s(_vm.venta.persona.email))]),_c('td',[_vm._v(_vm._s(_vm.venta.persona.celular))]),_c('td',[_vm._v(_vm._s(_vm.venta.cantidad))])])
}
var staticRenderFns = []

export { render, staticRenderFns }